$(function() {
        var xhrRunning = false;
        var buttonSubmitKeys = 'input[type="submit"], button[type="submit"], [data-type="submit"]';
        var Forms = {
            init() {
              this.setEvents( $(document).find( '.form.global' ) );
            },
            setEvents(form) {
                const self = this;
                const buttonSubmit = form.find( buttonSubmitKeys );
                form = buttonSubmit.closest( 'form' );
                $( 'input', form ).removeAttr( 'autocomplete' );
                if (form.length === 0) return;
                buttonSubmit.click(function(e) {
                    e.preventDefault();
                    form = $(this).closest( 'form' );
                    form.find( '.error' ).remove();
                    form.find( '.message' ).html( '' ).hide();
                    if ( Utils.validateForm(form) ) {
                        if (xhrRunning)
                            return;
                        if ( form.attr( 'action' ) ) {
                          form.submit();
                          return;
                        }
                        self.submit(form);
                        return;
                    }
                    return;
                });
                form.on( 'keyup, click', 'input[required]:not(.optional)', function(e) {
                    e.preventDefault();
                    var error_msgs = form.find( '.error' );
                    if ( error_msgs.length > 0 ) {
                        error_msgs.remove();
                    }
                });
                $( 'input[required]:not(.optional)', form ).keypress(function(e) {
                    var key = e.which;
                    if ( key == 13 ) {
                        $(this).closest( 'form' ).find( buttonSubmitKeys ).trigger( 'click' );
                        return false;
                    }
                });
            },
            submit(form) {
                const self = this;
                const $buttonSubmit = form.find( buttonSubmitKeys );
                const $textHolder = $buttonSubmit.find('.text');
                const action = form.find('input[name="action"]').val();
                const $message = form.closest('.subscribe').find('.block[data-block="1C"] .text');
                if (!action) {
                    return;
                }
                const params = form.serialize();
                const url = 'https://alt.hemway.com/api/index.php/subscribe?' + params;
                const payload = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow'
                };
                $textHolder.text('Processing');
                self.resetForm(form);
                fetch(url, payload)
                .then( response => response.json() )
                .then( response => {
                    if ( response.success ) {
                        $textHolder.text( 'Successful' );
                        if ( $( '.subscribe.alt' ).length ) {                        
                            Utils.setCookie( 'welcomeSubscription', true);
                        }
                    }
                    if ( response.message ) {
                        $message.find( 'p.small.four' ).text( response.message );
                        $message.removeClass( 'hidden' );
                    }
                }).finally(() => {
                    setTimeout(() => {
                        $textHolder.text( 'Sign Up' );
                        self.resetForm(form);
                    }, 600);
                })
                .catch( error => {
                    console.error( 'Error:', error );
                    return [];
                });
            },
            resetForm(form) {
                form[0].reset();
                form.find( 'button[type="submit"], input[type="submit"]' ).removeAttr( 'disabled' );
            },
        };
        Forms.init();
    });
    
var recaptchaWidgetIds = {};
function renderAllRecaptchas() {
    var recaptchaDivs = document.querySelectorAll('.g-recaptcha');
    if (typeof grecaptcha !== 'undefined' && recaptchaDivs.length) {
        recaptchaDivs.forEach(function(div, idx) {
        if (!div.hasAttribute('data-sitekey')) {
            div.setAttribute('data-sitekey', '6LcNLF0rAAAAAD2N6n2eay1deE3iMfszSFI16QXR');
        }
        div.setAttribute('data-size', 'invisible');
        recaptchaWidgetIds[div.closest('form').id || 'form-' + idx] = grecaptcha.render(div, {
            'sitekey': div.getAttribute('data-sitekey'),
            'size': 'invisible',
            'callback': function() {
            var form = div.closest('form');
            if (form) {
                form.onsubmit = null;
                form.submit();
            }
            }
        });
        });
    }
}

window.onloadCallback = renderAllRecaptchas;
$(function() {
    $('form').has('.g-recaptcha').each(function() {
        var $form = $(this);
        $form.on('submit', function(e) {
        var formId = this.id || 'form-' + $('form').index(this);
        var widgetId = recaptchaWidgetIds[formId];
        if (typeof grecaptcha !== 'undefined' && widgetId !== undefined && grecaptcha.getResponse(widgetId) === '') {
            e.preventDefault();
            grecaptcha.execute(widgetId);
        }
        });
    });
});
